module.exports = __webpack_public_path__ + "components/flag/static/square/mt-b4eecba364ca9a0f806c276894cdeac0.svg";